// extracted by mini-css-extract-plugin
module.exports = {"row":"_2VXry3TaJLB40gOq4sCdvM"};